import { render, staticRenderFns } from "./DashboardInfo.vue?vue&type=template&id=45280377"
import script from "./DashboardInfo.vue?vue&type=script&lang=js"
export * from "./DashboardInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports